import RequestContainer from 'components/containers/request.container';
import SubpageContainer from 'components/containers/subpage.container';
import FormInput from 'components/forms/form-input';
import FormSubmit from 'components/forms/form-submit';
import useFetch from 'hooks/useFetch';
import { Form } from 'react-final-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from 'redux/hooks';
import { selectRequest } from 'request/request.slice';
import {
  addCustomerActivity,
  getCustomerActivityDetails,
  updateCustomerActivity,
} from 'pages/admin/customer-activity/customer-activity.thunks';
import FormSelect from '../../../components/forms/form-select';
import React from 'react';
import CustomerActivityDownloads from './customer-activity-downloads/customer-activity-downloads';
import CustomerActivityShimmer from './customer-activity.shimmer';
import If from '../../../components/conditionals/if.conditional';
import CustomerActivitySearchUser from './customer-activity.search-user';

function CustomerActivityForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isCreating = id === 'new';
  let customerActivity = {
    name: '',
    sellerId: '',
    status: '',
    users: [],
  };
  const status = [
    {
      value: 'enabled',
    },
    {
      value: 'disabled',
    },
  ];
  let isFetching = false;

  if (!isCreating) {
    ({ isFetching, data: customerActivity } = useFetch('customer-activity-details', () =>
      getCustomerActivityDetails(id)
    ));
  }

  const onSubmit = async (values) => {
    if (isCreating) {
      const res = await addCustomerActivity(values);
      if (res) {
        setTimeout(() => navigate('/dashboard/customer-activity'), 2000);
      }
    } else {
      await updateCustomerActivity(id, values);
    }
  };

  return (
    <SubpageContainer title={isCreating ? 'Add New CustomerActivity' : 'Update Customer Activity'}>
      <RequestContainer loading={isFetching} fallback={<CustomerActivityShimmer />}>
        <Form
          onSubmit={onSubmit}
          initialValues={customerActivity}
          render={({ handleSubmit }) => {
            const { isLoading } = useAppSelector(selectRequest);
            return (
              <form onSubmit={handleSubmit}>
                <div className="space-y-6 bg-white rounded-md">
                  <div className="grid sm:w-full xl:w-3/4 grid-cols-1 p-6 gap-4">
                    <div className=" grid grid-cols-1 gap-4">
                      <FormInput name="name" label="Name" />
                      <FormInput name="sellerId" label="Seller Id" />
                      <FormSelect
                        values={status}
                        name="status"
                        label="Status"
                        optionValue="value"
                        optionLabel="value"
                        initialValue={status[0]?.value}
                      />
                      <CustomerActivitySearchUser />
                    </div>
                    <div className="flex justify-end">
                      <FormSubmit label="Submit" showButtonOnly disabled={isLoading} />
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        />
      </RequestContainer>
      <If show={id !== 'new'}>
        <CustomerActivityDownloads />
      </If>
    </SubpageContainer>
  );
}

export default CustomerActivityForm;
